import React from 'react';
import { useCurrentuser } from '@uplift/contexts';
import { ProviderDesktopNavigationProps } from './ProviderNavigation/ProviderDesktopNavigation';
import { ProviderNavigation, ProviderNavigationProps } from './ProviderNavigation';
import { FullScreenLayout, FullScreenWithoutBodyScrollLayout, FullScreenWithoutBodyScrollLayoutProps } from '../components';


export type ProviderLayoutProps = {
  loading?: boolean;
  background?: FullScreenWithoutBodyScrollLayoutProps['background'];
  showNavigation?: boolean;
  navigationOverrideStart?: ProviderNavigationProps['overrideStart'];

  showClientsSearch?: boolean;
  showNavigationLinks?: boolean;
  showProfile?: boolean;

  logoLink?: ProviderDesktopNavigationProps['logoLink'];
  navigationVariant?: ProviderDesktopNavigationProps['variant'];

  bodyScroll?: boolean;
  scrollToTopOnMount?: boolean;
};


export const ProviderLayout: React.FC<ProviderLayoutProps> = ({
  background = 'grey',
  showNavigation = true,
  showClientsSearch = true,
  showNavigationLinks = true,
  showProfile = true,
  bodyScroll = true,
  scrollToTopOnMount = true,
  ...props
}) => {
  const currentUser = useCurrentuser();
  const LayoutComponent = bodyScroll ? FullScreenLayout : FullScreenWithoutBodyScrollLayout;

  React.useLayoutEffect(() => {
    if (!scrollToTopOnMount) return;
    window.scrollTo(0, 0);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <LayoutComponent
      loading={props.loading}
      background={background}
      navigation={showNavigation
        ? (
          <ProviderNavigation
            avatarSrc={currentUser?.avatarSrc}
            variant={props.navigationVariant}
            logoLink={props.logoLink}
            showClientsSearch={showClientsSearch}
            showLinks={showNavigationLinks}
            showProfile={showProfile}
            showProfileLinks={showNavigationLinks}
            overrideStart={props.navigationOverrideStart}
          />
        )
        : undefined
      }
    >
      {props.children}
    </LayoutComponent>
  );
};
